import { isXOrY } from '../typeGuards/Channel';
const temporalFieldNames = new Set(['time', 'date', 'datetime', 'timestamp']);
export default function inferFieldType(channelType, field = '') {
  if (isXOrY(channelType) || channelType === 'Numeric') {
    return temporalFieldNames.has(field.toLowerCase()) ? 'temporal' : 'quantitative';
  }

  return 'nominal';
}